import { render, staticRenderFns } from "./account_detail.vue?vue&type=template&id=7136bf5e&scoped=true&"
import script from "./account_detail.vue?vue&type=script&lang=js&"
export * from "./account_detail.vue?vue&type=script&lang=js&"
import style0 from "./account_detail.vue?vue&type=style&index=0&id=7136bf5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7136bf5e",
  null
  
)

export default component.exports